import { sanitizeHtml, isHtml } from '../utils/sanitizeHtml';

/**
 * Renders a product short-description that may be either rich HTML (new, authored via
 * the rich-text editor) or legacy plain text. HTML is sanitised + rendered with prose
 * styling; plain text keeps its line breaks via `whitespace-pre-wrap`.
 */
export const DescriptionContent = ({ text, className = '', proseSize = 'prose-sm' }) => {
  if (!text || text === '<p></p>') return null;

  if (isHtml(text)) {
    return (
      <div
        className={`prose ${proseSize} max-w-none prose-headings:text-shrimp-dark prose-p:text-shrimp-text prose-li:text-shrimp-text prose-a:text-shrimp-green prose-img:rounded-lg ${className}`}
        dangerouslySetInnerHTML={{ __html: sanitizeHtml(text) }}
        data-testid="description-content"
      />
    );
  }

  return (
    <p className={`whitespace-pre-wrap ${className}`} data-testid="description-content">
      {text}
    </p>
  );
};

export default DescriptionContent;
